import React from 'react';
import Accordion from '../components/Accordion';
import './WelcomeMessage.css';

function WelcomeMessage({ homepageContent, latestDevotion }) {
  return (
    <section className="welcome-message">
      {latestDevotion ? (
          <>
            <h1>牧者靈修分享</h1>
            <h2>{latestDevotion.title}</h2>
            <Accordion collapsedHeight="20vh">
                <div dangerouslySetInnerHTML={{ __html: latestDevotion.content }} />
            </Accordion>
          </>
        ) : (
          <p>No devotion available.</p>
        )}
        <hr />
      <div dangerouslySetInnerHTML={{ __html: homepageContent.content }} />
    </section>
  );
}

export default WelcomeMessage;